import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const AdminSettings = () => {
    const [settings, setSettings] = useState({ telegram_link: '', telegram_username: '' });
    const token = localStorage.getItem('adminToken');

    useEffect(() => {
        axios.get('/api/settings')
            .then(res => setSettings(res.data))
            .catch(err => toast.error('Ошибка загрузки настроек'));
    }, []);

    const handleChange = (e) => {
        setSettings({ ...settings, [e.target.name]: e.target.value });
    }

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await axios.post('/api/settings', settings, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Настройки сохранены!');
        } catch (err) {
            toast.error('Ошибка сохранения.');
        }
    }

    return (
        <div className="admin-page">
            <h2>⚙️ Настройки сайта</h2>
            <form onSubmit={handleSave} className="admin-form">
                <div className="form-group">
                    <label>Ссылка на ваш Telegram</label>
                    <small>Используется в кнопках "Связь" и "Обсудить задачу"</small>
                    <input type="text" name="telegram_link" placeholder="https://t.me/username" value={settings.telegram_link} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Ваш юзернейм (для отображения)</label>
                    <input type="text" name="telegram_username" placeholder="@username" value={settings.telegram_username} onChange={handleChange} />
                </div>

                <button type="submit" className="btn-submit">Сохранить</button>
            </form>
        </div>
    );
};

export default AdminSettings;